import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import ApiService from '../../services/apiService';

const StripeProvider = ({ children }) => {
    const [stripePromise, setStripePromise] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const initializeStripe = async () => {
            try {
                const { publicKey } = await ApiService.getStripePublicKey();
                if (publicKey) {
                    setStripePromise(loadStripe(publicKey));
                }
            } catch (error) {
                console.error('Error loading Stripe:', error);
            } finally {
                setLoading(false);
            }
        };

        initializeStripe();
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
            </div>
        );
    }

    if (!stripePromise) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-center">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">Payment System Unavailable</h2>
                    <p className="text-gray-600">Please try again later or contact support.</p>
                </div>
            </div>
        );
    }

    return (
        <Elements stripe={stripePromise}>
            {children}
        </Elements>
    );
};

export default StripeProvider;
